import "../../styles/global.css";

const Feedback = () => {

    return (
        <div className="wrapper">
            <p>
                Please use {" "} 
                <a href="https://unlv.co1.qualtrics.com/jfe/form/SV_74naUafeHaSp9VI" target="_blank" rel="noopener noreferrer">
                this link 
                </a>{" "}
                to share your feedback. Thank you!
            </p>
        </div>
    );
};

export default Feedback;